import React from 'react';

export interface RenderTypeChipProps {
  rlpCompanyId?: number | null;
  teamId?: number | null;
  rlpPersonId?: number;
}

interface TypeInfo {
  type: string;
  className: string;
}

const typeChipBaseClassName = 'text-gray-600 dark:text-gray-300 text-xs px-2 py-0.5 rounded-full';

function getEntityTypeInfo({ rlpCompanyId, teamId, rlpPersonId }: RenderTypeChipProps): TypeInfo {
  if (!!rlpCompanyId || !!rlpPersonId) {
    return {
      type: 'RLP',
      className: 'bg-red-100 dark:bg-red-900'
    };
  }
  if (teamId === 7) {
    return {
      type: 'Commercial',
      className: 'bg-green-100 dark:bg-green-900'
    };
  }
  if (teamId === 6) {
    return {
      type: 'Prospect',
      className: 'bg-blue-100 dark:bg-blue-900'
    };
  }
  return {
    type: '',
    className: 'bg-blue-100 dark:bg-blue-900'
  };
}

export function renderTypeChip({ rlpCompanyId, teamId, rlpPersonId }: RenderTypeChipProps): React.ReactElement | null {
  const { type, className } = getEntityTypeInfo({ rlpCompanyId, teamId, rlpPersonId });

  if (!type) {
    return null;
  }

  return (
    <span className={`${typeChipBaseClassName} ${className}`}>
      {type}
    </span>
  );
}